import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'

// Inputs
import { Table, Button } from '../../../helpers';
import { Dialog } from 'primereact/dialog';
import moment from "moment"
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Tooltip } from "primereact/tooltip";

// common
import Loading from "../../../common/Loading"


// components
import EditPendingMaterialItem from './EditPendingMaterialItem';

// redux apis
import { fetchMaterialProductsByCategoryId, fetchMaterialProductsUOMsByCategoryId } from '../../../services/redux/reducers/materialMaster/materialMaster'
import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { updateMaterialMasterTempData, fetchMaterialProductRequestData } from '../../../services/redux/reducers/materialMaster/materialMasterTemp'

import DueInTimer from './DueInTimer';

// apis
import { duplicateMaterialIdFromBuyerReqAndPO, updatedMaterialMasterTemp } from '../../../services/api/materialMasterTemp';
import AssigneeCentralUser from './AssigneeCentralUser';
import { getFullName, sortArrayOfObjectsInAscendingDateOrder } from '../../../utils';
import { getMaterialIdTeamData } from '../../../services/api/materialIdTeam';
import { getApprovalInstances } from '../../../services/api/approvalInstances';
import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';
import { fetchApprovals } from '../../../services/redux/reducers/commonThunk';
import { DATE_TIME_FORMAT } from '../../../constants';

// constants
let priorityObj = {
    1: "High",
    2: "Medium",
    3: "Low",
    4: "Very Low"
}


const PendingMaterialItems = (props) => {

    const [materialItemTempObj, setMaterialItemTempObj] = useState({})
    const [buyerReqAndPOMaterialIds, setBuyerReqAndPOMaterialIds] = useState([])
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)
    const [isConfirmPreviewDialogVisible, setIsConfirmPreviewDialogVisible] = useState(false)
    const [materialsUserCategories, setMaterialsUserCategories] = useState([])
    const [materialIdTeam, setMaterialIdTeam] = useState([])
    const [approvalInstances, setApprovalInstances] = useState([])

    const userDetails = useSelector((state) => state.userDetails)
    const userId = useSelector((state) => state.userDetails.userId)
    const paginationParams = useSelector(state => state.materialMasterTemp.paginationParams)
    const isPageLoading = useSelector(state => state.materialMasterTemp.loading)
    const materialMasterTempData = useSelector(state => state.materialMasterTemp.materialMasterTempData)
    const searchParams = useSelector(state => state.materialMasterTemp.searchParams)
    
    // const materialIdTeam = useSelector(state => state.common.materialIdTeam)
    const approvals = useSelector(state => state.common.approvals)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const dispatch = useDispatch()

    useEffect(() => {
        getMaterialIdTeam()
        dispatch(fetchApprovals())
    }, [])

    useEffect(() => {
        const relatedCategoryMaterialIdTeam = materialIdTeam?.filter(eachTeam => eachTeam.accessType === "CATEGORY" && eachTeam.userId === userId)
        const userCategoryIds = _.uniqBy(relatedCategoryMaterialIdTeam, 'accessEntity').map(obj => obj.accessEntity)
        setMaterialsUserCategories(userCategoryIds)
    }, [materialIdTeam])

    useEffect(() => {
        if(materialMasterTempData.length){
            let relatedPartialSpecsMaterialItems = materialMasterTempData.filter(eachMaterial => eachMaterial.partialSpecsOnly)
            if(relatedPartialSpecsMaterialItems.length){
                let tampMaterialIds = _.uniqBy(_.map(relatedPartialSpecsMaterialItems, "materialId"))
                getPartialSpecsApprovalInstances(tampMaterialIds)
            }
        }
    }, [materialMasterTempData])

    const getMaterialIdTeam = async() => {
        setIsLoaderVisible(true)
        const response = await getMaterialIdTeamData({paginator: false})
        setIsLoaderVisible(false)
        if (response.failure){
            return dispatch(raiseToast({severity:'error', detail: response.data.error , life: 3000}))
        }
        setMaterialIdTeam(response.data)
    }

    const getPartialSpecsApprovalInstances = async (tempMaterialIds) => {
        setIsLoaderVisible(true)
        const relatedMaterialMasterPartialSpecsApprovals = approvals.filter(eachApproval => pmCompanyConfig.materialMasterPartialSpecsApprovalTypeIds.includes(eachApproval.approvalTypeId))
        const relatedMaterialMasterPartialSpecsApprovalIds = relatedMaterialMasterPartialSpecsApprovals.map(eachApproval => eachApproval.approvalId)

        const approverInstancesRes = await getApprovalInstances({ materialIds: tempMaterialIds, approvalIds: relatedMaterialMasterPartialSpecsApprovalIds, statusIds: [8] })
        console.log("approverInstancesRes", approverInstancesRes)
        setIsLoaderVisible(false)
        if (approverInstancesRes.failure) {
            return dispatch(raiseToast({ severity: 'error', summary: "Approval Instance", details: approverInstancesRes.data.error, life: 3000 }))
        }else{
            setApprovalInstances(approverInstancesRes.data.data)
        }
    }

    const updateAssigneeCentralUserId = async () => {

        let updatedObj = {
            materialId: materialItemTempObj.materialId,
            assigneeCentralUserId: userId,
            isAssigneeToMe: true
        }
        setIsLoaderVisible(true)
        let updateMaterialMasterTempResponse = await updatedMaterialMasterTemp(updatedObj)
        console.log("updateMaterialMasterTemp-response", updateMaterialMasterTempResponse)
        if (updateMaterialMasterTempResponse.failure) {
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'error', detail: updateMaterialMasterTempResponse.data.error, life: 3000 }))
        } else {
            setIsLoaderVisible(false)
            
            let updatedAssigneeMaterialItem = {}
            if(updateMaterialMasterTempResponse.data && updateMaterialMasterTempResponse.data.length > 0){
                updatedAssigneeMaterialItem = updateMaterialMasterTempResponse.data[0]
            }
            const updatedMaterialMasterTempData = materialMasterTempData.map((eachMaterialItem) => {
                if(eachMaterialItem.materialId === materialItemTempObj.materialId){
                    return {
                        ...eachMaterialItem,
                        ...updatedAssigneeMaterialItem,
                        assigneeUserFirstName: userDetails.userNameDetails?.firstName,
                        assigneeUserLastName: userDetails.userNameDetails?.lastName,
                    }
                }else{
                    return {...eachMaterialItem}
                }
            })

            dispatch(updateMaterialMasterTempData(updatedMaterialMasterTempData))
            editPendingMaterialItem(materialItemTempObj)
        }

    }

    const categoryBody = (rowData) => {
        let relatedCategory = props.materialCategory.find(category => category.categoryId === rowData.categoryId)
        if(relatedCategory){
            return relatedCategory.categoryName
        }
        else{
            return "-"
        }
    }

    const brandBody = (rowData) => {
        let relatedBrand = props.materialBrands.find(brand => brand.brandId === rowData.brandId)
        if(relatedBrand){
            return relatedBrand.brandName
        }
        else{
            return "-"
        }
    }

    const onClickEditMaterialItem = (row) => {
        let selectedMaterialItem = {...row}
        if(selectedMaterialItem.productSpecificationJSON){
            selectedMaterialItem.productSpecificationJSON = selectedMaterialItem.productSpecificationJSON.map(jsonString => JSON.parse(jsonString));
        }
        
        setMaterialItemTempObj({...selectedMaterialItem})

        let openToAssigneAndAssigneeUserstatus = getOpenToAssignAndAssigneeUserStatus(row)
        let { showOpenToAssign } = openToAssigneAndAssigneeUserstatus

        if(showOpenToAssign){
            if (!materialsUserCategories.length || (materialsUserCategories.length && materialsUserCategories.includes(row.categoryId))) {
                setIsConfirmPreviewDialogVisible(true)
            }
        }else if(row.assigneeCentralUserId === userId){
            editPendingMaterialItem(selectedMaterialItem)
        }else{

        }
    }

    const editPendingMaterialItem = async (selectedMaterialItemObj) => {

        let relatedCategory = props.materialCategory?.find(category => category.categoryId === selectedMaterialItemObj.categoryId)
        let relatedBrand = props.materialBrands?.find(brand => brand.brandId === selectedMaterialItemObj.brandId)
        let relatedUom = props.materialUOMData?.find(uom => uom.UOM === selectedMaterialItemObj.UOM)

        let materialItemObj = {
            ...props.materialItemInterimObj,
            categoryId: relatedCategory,
            brandId: relatedBrand, 
            UOM: relatedUom, 
            partialSpecsOnly: selectedMaterialItemObj.partialSpecsOnly
        }

        if(selectedMaterialItemObj.partialSpecsOnly){
            materialItemObj.productSpecification = selectedMaterialItemObj.productSpecification
        }

        if(relatedCategory){
            dispatch(fetchMaterialProductsByCategoryId(relatedCategory?.categoryId))
            dispatch(fetchMaterialProductsUOMsByCategoryId(relatedCategory?.categoryId))
        }

        props.setMaterialItemInterimObj(materialItemObj)
        await getBuyerReqAndPOMaterialIds(selectedMaterialItemObj.materialId)
        props.setVisibleEditPendingMaterialItem(true)
    }

    const getBuyerReqAndPOMaterialIds = async(materialId) => {
        setIsLoaderVisible(true)
        const buyerReqAndPOMaterialIdsResponse = await duplicateMaterialIdFromBuyerReqAndPO(materialId)
            console.log("buyerReqAndPOMaterialIds-response", buyerReqAndPOMaterialIdsResponse)
            if (buyerReqAndPOMaterialIdsResponse.failure){
                setIsLoaderVisible(false)
                return dispatch(raiseToast({severity:'error', summary: buyerReqAndPOMaterialIdsResponse.data.error , life: 3000}))
            } else {
                let materialIds = _.uniqBy(_.map(buyerReqAndPOMaterialIdsResponse?.data, "materialId"))
                setBuyerReqAndPOMaterialIds(materialIds)
                setIsLoaderVisible(false)
            }
    }

    const materialIdBody = (row) => {
        let priorityColor = "green"
        if(row["priority"]){
            let relatedPriority = priorityObj[row.priority]
            if(relatedPriority === "High"){
                priorityColor = "red"
            }else if(relatedPriority === "Medium"){
                priorityColor = "#5590ed"
            }else{
                priorityColor = "green"
            }
        }

        let { showOpenToAssign } = getOpenToAssignAndAssigneeUserStatus(row)

        let isEditMaterialItem = false

        if (row.assigneeCentralUserId === userId) {
            isEditMaterialItem = true
        } else if (showOpenToAssign) {
            if (!materialsUserCategories.length || (materialsUserCategories.length && materialsUserCategories.includes(row.categoryId))) {
                isEditMaterialItem = true
            }
        }

        let assigneeUserName = getFullName(row["assigneeUserFirstName"], row["assigneeUserLastName"])

        let rejectedMaterialApprovalInstance = null
        let rejectedUserName = null
        if(row.partialSpecsOnly){
            let relatedRejectApprovalInstances = approvalInstances.filter(eachApprovalInstances => eachApprovalInstances.materialId === row.materialId)
            if(relatedRejectApprovalInstances.length){
                if(relatedRejectApprovalInstances.length === 1){
                    rejectedMaterialApprovalInstance = relatedRejectApprovalInstances[0]
                }else{
                    let sortedApprovalInstances = sortArrayOfObjectsInAscendingDateOrder(relatedRejectApprovalInstances)
                    rejectedMaterialApprovalInstance = sortedApprovalInstances[0]
                }
    
                let relatedUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === rejectedMaterialApprovalInstance.processedBy)
                if (relatedUser) {
                    rejectedUserName = getFullName(relatedUser.firstName, relatedUser.lastName)
                }            
            }
        }
        
        return(
            <>
                <a 
                    onClick={()=> onClickEditMaterialItem(row)}
                    className={`custom-tooltip-materialid-${row.materialId}`}
                    style={{ cursor: "pointer", color: priorityColor, textDecoration: isEditMaterialItem ? 'underline':'none'}} 
                >
                    {row.materialId}
                </a>
                {row.partialSpecsOnly && rejectedMaterialApprovalInstance ? "*" : null}
                { !isEditMaterialItem || rejectedMaterialApprovalInstance ?
                    <Tooltip target={`.custom-tooltip-materialid-${row.materialId}`} position="top" autoHide>
                        {!isEditMaterialItem && `Current Assignee: ${assigneeUserName ? assigneeUserName: 'someone'}`}
                        <br />
                        {
                            row.partialSpecsOnly && rejectedMaterialApprovalInstance ? 
                                `Partial Specs rejected by ${rejectedUserName}, with remarks: ${rejectedMaterialApprovalInstance.processedRemarks}`
                                : null
                        }
                    </Tooltip>
                    : null
                }
            </>
        )
    }

    const createdByUserBody  = (row) => {
        const createdAtdate = moment(row.createdAt).format(DATE_TIME_FORMAT)
        if(row["firstName"]){
            let username = row["firstName"]
            if (row["lastName"]) {
                username += " " + row["lastName"]
            }
            
            return (
                <>
                    <span>{username}</span>
                    <br />
                    <span className='date'>{createdAtdate}</span>
                </>
            )
        }
        else{
            return "-"
        }
    }

    const getOpenToAssignAndAssigneeUserStatus = (materialItemData) => {
        const currentTime = new Date()
        const createdAtDate = new Date(materialItemData["createdAt"])
        const updatedAtDate = new Date(materialItemData["updatedAt"])

        const createdAtTime = createdAtDate.getTime()
        const updatedAtTime = updatedAtDate.getTime()

        let timeSinceCreated = currentTime - createdAtDate
        let oneHourInMillis = 3600000
        let twoSeconds = 2000

        let showAssigneeUser = false
        let showOpenToAssign = false

        if (timeSinceCreated < oneHourInMillis && (createdAtTime > (updatedAtTime - twoSeconds)) && createdAtTime < (updatedAtTime + twoSeconds)) {
            showAssigneeUser = true
            showOpenToAssign = true
        } else if ((createdAtTime < updatedAtTime - twoSeconds) && (timeSinceCreated < oneHourInMillis || timeSinceCreated > oneHourInMillis)) {
            showAssigneeUser = true
        } else if (timeSinceCreated > oneHourInMillis && (createdAtTime > (updatedAtTime - twoSeconds)) && createdAtTime < (updatedAtTime + twoSeconds)) {
            showOpenToAssign = true
        } else {
            showAssigneeUser = true
        }

        return { showAssigneeUser, showOpenToAssign}
    }

    const assigneeCentralUserBody  = (row) => {
        return <AssigneeCentralUser row={row} />
    }

    const dueInBody = (rowData) => {
        const createdAtdate = moment(rowData.createdAt).format("DD.MM.YYYY HH:mm")
    
        return (
            <>
                <span className={`custom-tooltip-${rowData.materialId}`}>
                    <DueInTimer createdAt={createdAtdate} materialId={rowData.materialId}/>
                </span>
            </>
        )
    }

    const tableColumns = [
        {
            header: 'MaterialId',
            field: 'materialId',
            style: { minWidth: '100px' },
            body: materialIdBody
        },
        {
            header: 'Category',
            field: 'categoryName',
            style: { minWidth: '100px' },
            body: categoryBody
        },
        {
            header: 'Brand',
            field: 'brandName',
            style: { minWidth: '100px' },
            body: brandBody
        },
        {
            header: 'Product Name',
            field: 'productName',
            style: { minWidth: '150px' }
        },
        {
            header: 'Specification',
            field: 'productSpecification',
            style: { minWidth: '200px' }
        },
        {
            header: 'Created By',
            field: 'createdBy',
            style: { minWidth: '120px' },
            body: createdByUserBody
        },
        {
            header: 'Due In',
            field: 'timer',
            style: { minWidth: '100px' },
            body: dueInBody
        },
        {
            header: 'Assignee User',
            field: 'assigneeCentralUserId',
            style: { minWidth: '150px' },
            body: assigneeCentralUserBody
        }
    ]

    const handleOnPageChange = (e) => {
        let materialMasterTempParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
        }

        if (searchParams.searchBy !== "all") {
            materialMasterTempParams[searchParams.searchBy] = searchParams.searchText?.trim()
        }
        dispatch(fetchMaterialProductRequestData({ ...searchParams, ...materialMasterTempParams }))
    }

    const handleVisibleEditPendingMaterialItem = () => {
        props.setVisibleEditPendingMaterialItem(false)
        props.setMaterialItemInterimObj({})
        props.setMaterialSpecification([])
        props.setMaterialSpecificationAttributes([])
    }

    return (
        <div className="">
            <Table
                lazy
                loading={isPageLoading}
                tableColumns={tableColumns}
                page={paginationParams.pageNo}
                totalRecords={paginationParams.totalRecords}
                rows={paginationParams.recordsPerPage}
                data={materialMasterTempData} 
                scrollable="true" 
                scrollHeight="500px" 
                paginator 
                excessPagesFound= {paginationParams.excessPagesFound}
                onPageChange={(e)=> handleOnPageChange(e)} 
            />
            <Dialog header="Edit Material Item" visible={props.visibleEditPendingMaterialItem} style={{ width: '75vw', minHeight: "60%" }} onHide={() => handleVisibleEditPendingMaterialItem()} >
                <EditPendingMaterialItem 
                    materialItemTempObj = { materialItemTempObj }
                    materialCategory={ props.materialCategory } 
                    materialIdTypes={ props.materialIdTypes } 
                    materialBrands={ props.materialBrands } 
                    materialUOMData={ props.materialUOMData }
                    materialProductsByCaterogy = {props.materialProductsByCaterogy}
                    materialItemInterimObj = {props.materialItemInterimObj}
                    setMaterialItemInterimObj={props.setMaterialItemInterimObj}
                    onSubmitMaterialItemInterimData = { props.onSubmitMaterialItemInterimData}
                    materialVariantProducts={props.materialVariantProducts}
                    setMaterialVariantProducts = { props.setMaterialVariantProducts }
                    materialSpecification = { props.materialSpecification }
                    setMaterialSpecification = { props.setMaterialSpecification }
                    materialProductsUOMsByCaterogy = { props.materialProductsUOMsByCaterogy }
                    materialSpecificationMandatoryTypes = { props.materialSpecificationMandatoryTypes }
                    materialIdTeam = { props.materialIdTeam }
                    materialSpecificationAttributes = { props.materialSpecificationAttributes }
                    setMaterialSpecificationAttributes = { props.setMaterialSpecificationAttributes }
                    materialMasterInterimData = { props.materialMasterInterimData }
                    materialItemObj = {props.materialItemObj}
                    setMaterialItemObj = { props.setMaterialItemObj }
                    getMaterialMasterItemData = { props.getMaterialMasterItemData }
                    isCategoryUser = { props.isCategoryUser }
                    buyerReqAndPOMaterialIds = {buyerReqAndPOMaterialIds}
                    setVisibleEditPendingMaterialItem={props.setVisibleEditPendingMaterialItem}
                />
            </Dialog>
            <ConfirmDialog
                visible={isConfirmPreviewDialogVisible} 
                onHide={() => {
                    setIsConfirmPreviewDialogVisible(false)
                }} 
                message= "This material-Id is available for assignment"
                header="Confirmation" 
                icon="pi pi-exclamation-triangle" 
                rejectLabel={"I'm just exploring"}
                acceptLabel={"Assign to Me"}
                reject={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    editPendingMaterialItem(materialItemTempObj)
                }} 
                accept={() => {
                    setIsConfirmPreviewDialogVisible(false)
                    updateAssigneeCentralUserId()
                }}
            />
            <Loading visible={isLoaderVisible} />
        </div>
    );
};

export default PendingMaterialItems;
